import * as React from 'react';

import { useIsSimplifiedPageHeader } from 'bundles/page-header/contexts/PageHeaderContext';
import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';
import type { SearchBarLocation } from 'bundles/search-common/constants';

import 'css!bundles/page-header/components/optimized/__styles__/SearchBarContainer';

type Props = {
  hideSearch?: boolean;
  isSearchPage?: boolean;
  pageLocation?: SearchBarLocation;
  shouldFocusSearch?: boolean;
  enableOneStepSearch?: boolean;
  shouldShowExposedSearchAndReg?: boolean;
  smallSearchBar?: boolean;
};

const SearchBarContainer = (props: Props) => {
  const isSimplifiedPageHeader = useIsSimplifiedPageHeader();

  // In legacy PageHeader this has a wrapper (where it's included with the ExploreButton),
  // here we need to add a container to give it a proper width.
  return (
    <div className={isSimplifiedPageHeader ? 'rc-SearchBarContainer--unified' : 'rc-SearchBarContainer'}>
      <SearchBar {...props} />
    </div>
  );
};

export default SearchBarContainer;
